export class ExternalBranchesFilterEntity {
  page?: number
  limit?: number
}
